import { Controller } from '@hotwired/stimulus'

const INPUT = ':is(input:not([type=hidden]), select, textarea, [contenteditable=true]):not(:disabled)'

// I-UX-EDIT-01 one edit mode per detail page (resources/_field_cards).
// I-UXF-od-6: read mode has no click-to-edit (values are copied by selecting them); Upravit / E / ?focus=<field> open it.
// Edit mode (on the page's form): focuses the first invalid field, else the clicked one, else the first input; Esc =
// Zrušit (the unsaved-changes guard of dirty_forms.ts asks), unless a dialog, dropdown or popover takes the Esc.
export default class RecordEditController extends Controller<HTMLElement> {
  static override targets = ['cancel']
  static override values = { focus: String }
  declare readonly cancelTarget: HTMLAnchorElement
  declare readonly hasCancelTarget: boolean
  declare readonly focusValue: string

  // An invalid save (422) is morphed into the same page (turbo-refresh-method morph): no new connect, so turbo:render.
  private readonly onRender = (): void => this.invalidInput()?.focus()

  override connect(): void {
    if (!this.hasCancelTarget) return

    const field = this.focusValue ? `[data-field="${CSS.escape(this.focusValue)}"] ${INPUT}` : null
    const input = this.invalidInput() ?? (field ? this.element.querySelector<HTMLElement>(field) : null) ??
      this.element.querySelector<HTMLElement>(`[data-field] ${INPUT}`)
    input?.focus()
    document.addEventListener('turbo:render', this.onRender)
  }

  override disconnect(): void {
    document.removeEventListener('turbo:render', this.onRender)
  }

  private invalidInput(): HTMLElement | null {
    return this.element.querySelector<HTMLElement>(`${INPUT}[aria-invalid=true]`)
  }

  cancel(event: KeyboardEvent): void {
    if (event.defaultPrevented || document.querySelector('dialog[open], details.dropdown[open], :popover-open')) return

    event.preventDefault()
    this.cancelTarget.click()
  }
}
